import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import Home from "@/pages/Home";
import PropertyDetail from "@/pages/PropertyDetail";
import BookingSuccess from "@/pages/BookingSuccess";
import Admin from "@/pages/Admin";
import Blog from "@/pages/Blog";
import BlogPost from "@/pages/BlogPost";
import Quiz from "@/pages/Quiz";
import CreaturePreview from "@/pages/CreaturePreview";
import PrivacyNotice from "@/pages/PrivacyNotice";
import TermsOfUse from "@/pages/TermsOfUse";
import Experiencia from "@/pages/Experiencia";
import PortalHuesped from "@/pages/PortalHuesped";
import PortalBienvenida from "@/pages/PortalBienvenida";
import QuizPopup from "@/components/QuizPopup";
import BeachCreatures from "@/components/BeachCreatures";
import { LanguageProvider } from "@/contexts/LanguageContext";

function App() {
  return (
    <div className="App">
      <LanguageProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/villas/:slug" element={<PropertyDetail />} />
            <Route path="/reserva-confirmada" element={<BookingSuccess />} />
            <Route path="/admin" element={<Admin />} />
            <Route path="/blog" element={<Blog />} />
            <Route path="/blog/:slug" element={<BlogPost />} />
            <Route path="/quiz" element={<Quiz />} />
            <Route path="/aviso-de-privacidad" element={<PrivacyNotice />} />
            <Route path="/condiciones-de-uso" element={<TermsOfUse />} />
            <Route path="/experiencia" element={<Experiencia />} />
            <Route path="/portal/:token" element={<PortalHuesped />} />
            <Route path="/portal/:token/bienvenida" element={<PortalBienvenida />} />
            <Route path="/_creatures" element={<CreaturePreview />} />
          </Routes>
          <QuizPopup />
          <BeachCreatures />
          <Toaster position="top-center" richColors />
        </BrowserRouter>
      </LanguageProvider>
    </div>
  );
}

export default App;
